import { SelectedSortOption } from './types';

export const getSortIconType = (value: SelectedSortOption | null) => {
  if (value?.order === 'asc') {
    return 'sort-asc';
  }

  return 'sort-desc';
};
